<template>
  <div>
    <template v-if="loading_telefone === true">
      <loading />
    </template>
    <template v-else>
      <div class="col s12 m12 no-padding contact-section">
        <div class="col s12 no-padding title-buttons-wrapper">
            <div class="col s6">
            <h6>
              Telefone
              <i v-if="telefones.length > 0" class="material-icons">check</i>
              <template v-else>
                <i v-if="meta.censo_domain[selectedMunicipio].formulario_documentos_obrigatorios.contatos.includes('telefones')" class="material-icons red-text">error</i>
              </template>
            </h6>
            </div>
            <div class="col s6">
            <a v-if="form_telefone === false" @click="addNewPhone" class="waves-effect waves-light btn right">Adicionar telefone</a>
            <a v-else @click="addNewPhone" class="waves-effect waves-light btn red right">Cancelar</a>
            </div>
        </div>
        <div v-if="form_telefone === false" class="col s12 no-padding lista-telefone-wrapper">
          <template v-for="(tel, i) in telefones">
            <div class="col s12 m6 l3" v-bind:key="i">
              <div class="card">
                <div class="card-content">
                  <div class="col s12">
                    <p>
                      <i v-if="tel['tipo'] === 'M'" class="material-icons">phone_android</i>
                      <i v-else class="material-icons">phone</i>
                      <span>
                        ({{ tel['ddd'] }})
                        {{ tel['prefixo'] }}-{{ tel['sufixo'] }}
                      </span>
                    </p>
                  </div>
                </div>
                <div class="card-action">
                    <div class="col s12 censo">
                      <a @click="removeTelefone(tel['tel_id'])" title="Remover telefone" class="red-text action-delete">
                        <i class="material-icons">delete</i>
                      </a>
                    </div>
                  </div>
              </div>
            </div>
          </template>
        </div>
        <template v-else>
          <div class="col s12 no-padding form-telefone-wrapper">
            <div class="input-field col s12 m2">
              <select v-model="new_telefone.tel_tipo" id="tel_tipo" v-bind:class="{'invalid': error_fields['tel_tipo']}">
                  <option value="" selected>Selecione</option>
                  <option value="M">Móvel</option>
                  <option value="F">Fixo</option>
              </select>
              <label for="tipo_tel">Tipo</label>
              <span class="helper-text" data-error="Este campo deve ser preenchido"></span>
            </div>
            <div class="input-field col s12 m3">
              <input v-model="new_telefone.tel_completo" v-mask="(new_telefone.tel_tipo === 'M' ? ['(##) #####-####'] : ['(##) ####-####'])" id="tel_completo" v-bind:class="{'invalid': error_fields['tel_completo']}" type="text">
              <label for="phone_number">Número</label>
              <span class="helper-text" data-error="Este campo deve ser preenchido"></span>
            </div>
            <div class="input-field col s12 m2">
              <select v-model="new_telefone.tel_class" id="tel_class" v-bind:class="{'invalid': error_fields['tel_class']}">
                  <option value="" selected>Selecione</option>
                  <option value="R">Residencial</option>
                  <option value="CO">Comercial</option>
                  <option value="CR">Correspondência</option>
                  <option value="RC">Recado</option>
                  <option value="RA">Ramal</option>
              </select>
              <label for="class_tel">Classificação</label>
              <span class="helper-text" data-error="Este campo deve ser preenchido"></span>
            </div>
            <div class="input-field col s12 m3">
              <textarea v-model="new_telefone.tel_obs" id="obs_fone" class="materialize-textarea"></textarea>
              <label for="obs_fone">Observação</label>
            </div>
          </div>
          <div class="col s12 m12">
            <a @click="prepareSubmitTelefone" v-bind:disabled="verificaForm === false" class="waves-effect waves-light btn right">Salvar</a>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import Loading from '@/components/Loading.vue'
import axios from 'axios'
import {CONFIG} from '@/config/config.js'
import SocialService from '@/services/social-service.js'

let socialService = new SocialService(CONFIG.URL_SOCIAL_API_V2)

export default {
  name: 'Telefones',
  components: {
    loading: Loading
  },
  props: {
    telefones_data: Array,
    pf_id: String
  },
  data (){
    return {
      meta: this.$store.state.meta.data,
      form_telefone: false,
      loading_telefone: false,
      telefones: this.telefones_data,
      new_telefone: {
        tel_tipo: null,
        tel_ddi: 55,
        tel_completo: null,
        tel_class: null,
        tel_obs: null
      },
      error_fields: {},
      selectedMunicipio: localStorage.selectedMunicipio
    }
  },
  computed: {
    verificaForm: function() {
      let keys = ['tel_tipo', 'tel_ddi', 'tel_completo', 'tel_class']

      return (
        ['tel_tipo', 'tel_ddi', 'tel_completo', 'tel_class'].filter((k) => this.new_telefone[k] && this.new_telefone[k] != '').length >= 4
      )
    }
  },
  methods: {
    getTelefones(){
      axios.get(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/telefones/${this.pf_id}/`)
      .then((response) => {
        this.telefones = []
        response.data.data.SocialAPI.current.forEach((tel) => {
          this.telefones.push({
            tel_id: tel['tel_id'],
            tipo: tel['tel_tipo'],
            dddi: tel['tel_dddi'],
            ddd: tel['tel_ddd'],
            prefixo: tel['tel_prefixo'],
            sufixo: tel['tel_sufixo'],
            verif_sms: tel['tel_verif'],
            verif_manual: tel['tel_manual_verif'],
            tel_class: tel['tel_class'],
            tel_obs: tel['tel_obs'],
          })
          this.$emit('statusChange')
        })
      })
      .catch((error) => {

      })
      .finally(() => {
        this.loading_telefone = false
        setTimeout(() => {
          this.form_telefone = false
        }, 100)
      })
    },
    async submitInsertTelefone(telefone){
      axios.post(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/telefones/`, {
        ...telefone,
        ...{
          'pf_id': this.pf_id,
          'device': await socialService.getDeviceInfo()
        }
      })
      .then((response) => {
        this.getTelefones()
      })
      .catch((error) => {
        M.toast({html: 'Não foi possível realizar esta operação...verifique a sua conexão com a internet e tente novamente!'})
        this.loading_telefone = false
        this.form_telefone = false
      })
    },

    prepareSubmitTelefone(){
      this.loading_telefone = true
      let a = this.titulo //Atual

      let telefone = {
        pf_id: this.pf_id,
        tel_tipo: this.new_telefone.tel_tipo,
        tel_ddi: this.new_telefone.tel_ddi,
        tel_ddd: this.new_telefone.tel_completo.substr(1, 2),
        tel_prefixo: (this.new_telefone.tel_tipo === 'M' ? this.new_telefone.tel_completo.substr(5, 5) : this.new_telefone.tel_completo.substr(4, 5)),
        tel_sufixo: (this.new_telefone.tel_tipo === 'M' ? this.new_telefone.tel_completo.substr(11) : this.new_telefone.tel_completo.substr(10)),
        tel_class: this.new_telefone.tel_class,
        tel_obs: this.new_telefone.tel_obs,
      }
      return this.submitInsertTelefone(telefone)
    },
    addNewPhone() {
      this.form_telefone = !this.form_telefone
      if (this.form_telefone === true) {
        this.loadFields()
        this.new_telefone = {
          tel_tipo: null,
          tel_ddi: 55,
          tel_completo: null,
          tel_class: null,
          tel_obs: null
        }
      }
    },
    async removeTelefone(tel_id){
      this.loading_telefone = true
      axios({
        method: "DELETE",
        url: `${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/telefones/${this.pf_id}/${tel_id}/`, 
        data: {
          device: await socialService.getDeviceInfo()
        }
      })
      .then((response) => {
        this.telefones.forEach((item, i) => {
          if(item['tel_id'] === tel_id){
            this.telefones.splice(i, 1)
          }
        })
        this.$emit('statusChange')
        this.loading_telefone = false
      })
      .catch((error) => {
        M.toast({html: 'Não foi possível realizar esta operação...verifique a sua conexão com a internet e tente novamente!'})
        this.loading_telefone = false
        setTimeout(() => {
          this.initFields()
        }, 100)
      })
    },
    verificaStatusPasso(){
      let keys = ['tel_completo']
      let selectKeys = ['tel_tipo', 'tel_class']

      let status = true //Até que se prove o contrário
      keys.forEach((key) => {
        if(this.new_telefone[key] == null || this.new_telefone[key] == ''){
          status = false
          this.$set(this.error_fields, key, true)
        } else {
          this.$set(this.error_fields, key, false)
        }
      })

      selectKeys.forEach((sKey) => {
        try{
          if(this.new_telefone[sKey] == null || this.new_telefone[sKey] == ''){
            status = false
            M.FormSelect.getInstance(document.getElementById(sKey)).wrapper.classList.add('invalid')
            this.$set(this.error_fields, sKey, false)
          } else {
            M.FormSelect.getInstance(document.getElementById(sKey)).wrapper.classList.remove('invalid')
            this.$set(this.error_fields, sKey, true)
          }
        } catch(e) {
          status = false
        }
      })
      return status
    },
    loadFields() {
      setTimeout(() => {
        M.updateTextFields()
        M.FormSelect.init(document.querySelectorAll('select'))
        M.Tooltip.init(document.querySelectorAll('.tooltipped'))
      }, 200)
    },
  },
  watch: {
    new_telefone: {
      handler: function(updated, old){
        this.changed = true
        setTimeout(() => {
          this.verificaStatusPasso()
        }, 100)
      },
      deep: true
    }
  },
  mounted(){
    setTimeout(() => {
      this.verificaStatusPasso()
    }, 500)
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/steps/contatos/Telefones.vue